import React, { useState } from 'react';

import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useQuery } from '@tanstack/react-query';
import { Control } from 'react-hook-form';

import CustomChip from './CustomChip';
import AddTagsDrawer from './drawers/AddTagsDrawer';
import RISelectComponent from './SelectComponent';
import { fetchTags } from '../axiosClient/dictionaryApi';
import { IOptions } from '../interfaces/IOptions';

interface Props {
  name: string;
  control?: Control;
  loading?: boolean;
  type?: string;
  valueKey?: string;
  required?: boolean;
}

const LinkSelectedFiled: React.FC<Props> = ({
  name,
  control,
  valueKey,
  required = false,
}) => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const { data: options, isLoading } = useQuery({
    queryKey: ['admin_tags'],
    queryFn: async () => {
      const response = await fetchTags();
      return response.results;
    },
  });

  return (
    <>
      <Grid container alignItems="start" mt={2}>
        <Grid size={{ sm: 9 }}>
          <RISelectComponent
            name={name}
            control={control}
            options={options || []}
            label="Add Tags"
            labelKey="name"
            valueKey={valueKey}
            required={required}
            loading={isLoading}
            isMultiselect={true}
            renderCustomComponent={(value: string | IOptions | number) => (
              <CustomChip
                key={(value as IOptions)?.id}
                label={(value as IOptions)?.name}
              />
            )}
          />
        </Grid>
        <Grid size={{ sm: 3 }}>
          <Button
            variant="text"
            startIcon={<ManageSearchIcon />}
            onClick={() => {
              setOpenDrawer(true);
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Add Tag
          </Button>
        </Grid>
      </Grid>
      <AddTagsDrawer
        open={openDrawer}
        onClose={handleCloseDrawer}
        tagsList={options || []}
        isLoading={isLoading}
        control={control}
        name={name}
      />
    </>
  );
};

export default LinkSelectedFiled;
